// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1fWNC","actionsCol":"EnrolledClinics_actionsCol__KM9LO"};